let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kdX7b")).then(() => parcelRequire('4nbVT'));